import { useRef, useState } from 'react'
import Button from '@components/Button'
import CircleLoader from '@components/CircleLoader'
import MonerisFrame from 'credit-cards/moneris/components/MonerisFrame'
import './styles.scss'

const AddCreditCard = () => {
    const [isLoading, setIsLoading] = useState(true)
    const [cardHolder, setCardHolder] = useState('')
    const [token, setToken] = useState('')
    const [error, setError] = useState(null)
    const iframeRef = useRef(null)
    const cardholderInputRef = useRef(null)

    const onLoad = () => {
        setIsLoading(false)
    }

    const onSubmit = () => {
        if (cardholderInputRef.current && !cardholderInputRef.current.value) {
            setError(<T>Moneris.Creditcard.Error.General</T>)
            return
        } else {
            setCardHolder(cardholderInputRef.current.value)
        }
        setError('')
        setIsLoading(true)
        iframeRef.current.contentWindow.postMessage('tokenize', `${MONERIS_TOKENIZATION_PAGE}/HPPtoken/index.php'`)
    }

    const setErrorHandler = error => {
        setError(error)
        setIsLoading(false)
    }

    return (
        <>
            <div className="moneris d-flex flex-column align-items-left">
                {isLoading && (
                    <>
                        <CircleLoader className="loader" />
                        <p data-moneris-token={token} className="invisible" />
                        <p data-moneris-cardholder={cardHolder} className="invisible" />
                    </>
                )}
                <MonerisFrame
                    forwardedIframeRef={iframeRef}
                    forwardedInputRef={cardholderInputRef}
                    setToken={setToken}
                    setError={setErrorHandler}
                    onLoad={onLoad}
                    isLoading={isLoading}
                />
                {!isLoading && (
                    <Button onClick={onSubmit}>
                        <T>moneris.creditcard.submit.label</T>
                    </Button>
                )}
                <p className="text-center mt-3 error text-capitalize">{error}</p>
            </div>
        </>
    )
}

export default withTranslate(AddCreditCard)
